export default __webpack_public_path__ + "static/media/burning-money.fe35ce3f.gif";